import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import en from "./locales/en.json";
import de from "./locales/de.json";

const STORAGE_KEY = "tenant-management-lang";
const SUPPORTED_LANGS = ["de", "en"] as const;
type SupportedLng = (typeof SUPPORTED_LANGS)[number];

function getBrowserLanguage(): SupportedLng | null {
  const raw = typeof navigator !== "undefined" ? navigator.language : null;
  if (!raw) return null;
  const code = raw.split("-")[0].toLowerCase();
  if (SUPPORTED_LANGS.includes(code as SupportedLng)) return code as SupportedLng;
  const preferred = typeof navigator !== "undefined" ? navigator.languages : [];
  for (const lang of preferred) {
    const c = lang?.split("-")[0].toLowerCase();
    if (SUPPORTED_LANGS.includes(c as SupportedLng)) return c as SupportedLng;
  }
  return null;
}

function getInitialLanguage(): SupportedLng {
  const stored = typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
  if (stored && SUPPORTED_LANGS.includes(stored as SupportedLng)) return stored as SupportedLng;
  return getBrowserLanguage() ?? "de";
}

const resources = {
  en: {translation: en},
  de: {translation: de},
};

void i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "de",
  supportedLngs: [...SUPPORTED_LANGS],
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
export {STORAGE_KEY, SUPPORTED_LANGS};
